import { api } from '@iso/utils/axios.configs';
import { ApiRouters } from '@iso/utils/apiRouters';

export const getAPIBlanksDropDown = (params) => {
	const url = ApiRouters.API_BLANKS_DROP_DOWN;
	return api.get(url, { params });
};

export const postAPIBlanksDropDown = (body) => {
	const url = ApiRouters.API_BLANKS_DROP_DOWN;
	return api.post(url, body);
};

export const getAPIBlanksDropDownDetail = (id) => {
	const url = `${ApiRouters.API_BLANKS_DROP_DOWN}/${id}`;
	return api.get(url);
};

export const putAPIBlanksDropDownDetail = (id, body) => {
	const url = `${ApiRouters.API_BLANKS_DROP_DOWN}/${id}`;
	return api.put(url, body);
};

export const deleteAPIBlanksDropDown = (id) => {
	const url = `${ApiRouters.API_BLANKS_DROP_DOWN}/${id}`;
	return api.delete(url);
};

// export const createQuesReadAloud = (body) => {
// 	const url = ApiRouters.READALOUD;
// 	return api.post(url, body);
// };

// export const updateReadAloudDetail = (body) => {
// 	const url = `${ApiRouters.READALOUD}/${body.id}`;
// 	return api.put(url, body);
// };

